import { Card, Grid, Typography } from '@mui/material';
import { BakeasyIconButtonBack } from '../buttons/BakeasyIconButtons';

export interface BakeasyAppBarProps {
  title?: string;
  clickable?: boolean;
  icon?: any;
  menus?: any;
  onBackClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

export function BakeasyAppBar(props: BakeasyAppBarProps) {
  return (
    <Card sx={{ display: 'flex', justifyContent: 'flex-between' }}>
      <Grid
        container
        spacing={1}
        sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: 1 }}
      >
        <Grid item xs={12} sm={12} md={4} lg={3} xl={3}>
          <Grid container sx={{ alignItems: 'center', justifyContent: 'start' }}>
            <div className="tableOptions">
              <BakeasyIconButtonBack onClick={props?.onBackClick} />
              <Grid item sx={{ alignItems: 'center', display: 'flex' }}>
                <Typography> {props?.title}</Typography>
              </Grid>
            </div>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={7} lg={6} xl={6}>
          {props?.menus && (
            <Grid container sx={{ alignItems: 'center', justifyContent: 'end' }}>
              {props?.menus}
            </Grid>
          )}
        </Grid>
      </Grid>
    </Card>
  );
}
